import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import authenticationReducer from "../features/authentication/authenticationSlice"
import onboardingProcessReducer from "../features/onboarding/onboardingProcessSlice"
import practiceProfileProcessReducer from "../features/practiceProfile/practiceProfileProcessSlice"
import termsOfUseReducer from "../features/termsOfUse/termsOfUseSlice"
import userReducer from "../domain/Account/userSlice"
import userRolesReducer from "../domain/Account/userRolesSlice"
import { setupAxiosInterceptors } from "../features/authentication/apiClient"
import practiceReducer, { listenerMiddleware } from "../domain/Practice/model"
import providerReducer from "../domain/Provider/model"
import practiceLoaderReducer from "../domain/Practice/loaders/loader"
import providerLoaderReducer from "../domain/Provider/loader"
import contentManagementReducer from "../domain/CMS/model"
import errorHandlerReducer from "../features/errors/errorSlice"
import viewModelReducer from "../domain/ViewModel/model"
import searchServiceReducer from "../domain/Search/loader"
import profileReducer from "../domain/Profile/model"
import referralReducer from "../domain/Referral/loader"
import practicesReducer from "../domain/Practices/model"
import sidebarNavReducer from "../features/shared/components/MainNavigation/sidebarNavSlice"
import ariaLiveReducer from "../features/ariaLive/ariaLiveSlice"

const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "[::1]")

const isAllowedEnv =
  !!process.env.NODE_ENV && ["dev", "stage"].includes(process.env.NODE_ENV)

const allowDevTools = isLocalhost || isAllowedEnv

export const configureStoreThunk = () => {
  return configureStore({
    reducer: {
      authentication: authenticationReducer,
      onboardingProcess: onboardingProcessReducer,
      practiceProfileProcess: practiceProfileProcessReducer,
      termsOfUse: termsOfUseReducer,
      user: userReducer,
      userRoles: userRolesReducer,
      practice: practiceReducer,
      practiceLoader: practiceLoaderReducer,
      profile: profileReducer,
      provider: providerReducer,
      providerLoader: providerLoaderReducer,
      contentManagement: contentManagementReducer,
      errorHandler: errorHandlerReducer,
      viewModel: viewModelReducer,
      searchService: searchServiceReducer,
      referralPacket: referralReducer,
      practices: practicesReducer,
      sidebarNav: sidebarNavReducer,
      ariaLive: ariaLiveReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().prepend(listenerMiddleware.middleware),
    devTools: allowDevTools,
  })
}

export const store = configureStoreThunk()

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

setupAxiosInterceptors()
